module.exports = __webpack_public_path__ + "img/6.05466493.jpg";